import { useMemo } from 'react';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

export type Issue = {
	graphic: string;
	issueId: string;
	stances: readonly string[];
	title: string;
};

type Result = ModelHookResult<{
	headingText: string;
	issues: Issue[];
}>;

export function useTopIssues(): Result {
	const {
		data: { displayName, lastName, enrichedData },
	} = useDecisionMakerProfilePageData();

	const issues = useMemo(
		() =>
			enrichedData?.issues.map((issue) => ({
				graphic: issue.graphic,
				issueId: issue.issueId,
				stances: issue.stances,
				title: issue.title,
			})) ?? [],
		[enrichedData],
	);

	return {
		data: {
			headingText: `Where ${lastName ?? displayName} stands on these issues`,
			issues,
		},
	};
}
